<!-- components/LoaderOverlay.vue -->
<template>
  <div v-if="loader.loading" class="loader-overlay">
    <div class="loader-box">
      <div class="spinner"></div>
      <p>{{ loader.message }}</p>
    </div>
  </div>
</template>

<script setup>
import { useLoaderStore } from '@/stores/loader'
const loader = useLoaderStore()
</script>

<style scoped>
.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader-box {
  background: white;
  padding: 20px 40px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 0 20px rgba(0,0,0,0.2);
}
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #42b883;
  border-radius: 50%;
  margin: 0 auto 10px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
